import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";


const SaveModal = ({
  show,
  onHide,
  folders = [],
  savedFolders = [],
  setSavedFolders,
  onToggleFolder,
  onCreateFolder,
  loading = false,
  saveSummary = { total: 0, added: 0, existing: 0 },
}) => {
  const [newFolderName, setNewFolderName] = useState("");
  const [creating, setCreating] = useState(false);

  // anti-spam
  const [togglingId, setTogglingId] = useState(null);
  const [creatingBusy, setCreatingBusy] = useState(false);

  useEffect(() => {
    if (show) {
      setSavedFolders([]); // her açılışta sıfırla
      setTogglingId(null);
      setCreating(false);
      setCreatingBusy(false);
      setNewFolderName("");
    }
  }, [show, setSavedFolders]);

  const handleToggleClick = async (folderId, willSelect) => {
    if (togglingId !== null || creatingBusy) return;
    setTogglingId(folderId);
    try {
      await Promise.resolve(onToggleFolder(folderId, willSelect));
    } finally {
      setTimeout(() => setTogglingId(null), 500);
    }
  };

  const handleCreate = async () => {
    const name = newFolderName.trim();
    if (name.length < 2 || creatingBusy || togglingId !== null) return;
    try {
      setCreatingBusy(true);
      await Promise.resolve(onCreateFolder(name));
      setNewFolderName("");
      setCreating(false);
    } finally {
      setTimeout(() => setCreatingBusy(false), 500);
    }
  };

  return (
    <Modal
      show={show}
      onHide={creatingBusy || togglingId !== null ? undefined : onHide}
      centered
      backdrop={creatingBusy || togglingId !== null ? "static" : true}
      keyboard={!(creatingBusy || togglingId !== null)}
    >
      <Modal.Header closeButton={!creatingBusy && togglingId === null}>
        <Modal.Title>Kaydet</Modal.Title>
      </Modal.Header>

      {saveSummary && (
        <div className="p-3 pb-0 justify-content-center text-center">
          <div className="alert alert-info mb-0" style={{ fontSize: 14 }}>
            {saveSummary.total === 1 && saveSummary.added === 0 && saveSummary.existing === 1 ? (
              <>Yayın zaten <strong>kayıtlı</strong>.</>
            ) : saveSummary.added === 0 && saveSummary.existing > 0 ? (
              <>Tüm yayınlar zaten <strong>kayıtlı</strong>. Yayınları bir klasörünüze de ekleyebilirsiniz.</>
            ) : saveSummary.added > 0 && saveSummary.existing === 0 ? (
              <>
                <strong>{saveSummary.added}</strong> yayın <strong>kayıtlarınıza</strong> eklendi.
              </>
            ) : saveSummary.added > 0 && saveSummary.existing > 0 ? (
              <>
                <strong>{saveSummary.added}</strong> yayın <strong>kaydedildi</strong>,{" "}
                <strong>{saveSummary.existing}</strong> yayın zaten <strong>kayıtlıydı. </strong> 
                 Yayınları bir klasörünüze de ekleyebilirsiniz.
              </>
            ) : (
              <>İşlem özeti gösterilemiyor.</>
            )}
          </div>
        </div>
      )}

      <Modal.Body style={{ padding: 0, background: "#f9f9fb" }}>
        <div style={{ maxHeight: 380, overflowY: "auto" }}>
          {loading && (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status" />
            </div>
          )}
          {!loading && folders.length === 0 && (
            <div className="text-center text-newdarkfume py-4">
              <div className="mb-2 small fw-semibold text-danger">Klasör bulunamadı</div>
              <div className="small">Aşağıdan <strong>Klasör Oluştur</strong> ile yeni bir klasör ekleyin.</div>
            </div>
          )}
          {!loading && (
            <>
              {/* Sadece klasörler */}
              {folders.map((folder) => {
                const folderName = folder.foldername || folder.name;
                const isActive = savedFolders.includes(folder.id);
                const busy = togglingId === folder.id;

                return (
                  <div
                    key={folder.id}
                    className={`d-flex align-items-center justify-content-between py-3 px-4 border-bottom ${isActive ? "bg-light" : ""}`}
                    style={{
                      cursor: isActive || busy || creatingBusy ? "not-allowed" : "pointer",
                      opacity: isActive || busy ? 0.65 : 1,
                      pointerEvents: isActive || busy || creatingBusy ? "none" : "auto",
                    }}
                    onClick={() => {
                      if (!isActive) handleToggleClick(folder.id, true);
                    }}
                  >

                    <span style={{ fontWeight: 500 }}>{folderName}</span>

                    <OverlayTrigger
                      key={`${folder.id}-${isActive}-${busy}`}
                      placement="left"
                      delay={{ show: 100, hide: 10 }}
                      overlay={
                        <Tooltip id={`save-tip-${folder.id}`}>
                          {busy ? "İşleniyor…" : (isActive ? "Bu klasörde kayıtlı" : "Bu klasöre kaydet")}
                        </Tooltip>
                      }
                    >
                      <span
                        className="ms-2"
                        title={busy ? "İşleniyor…" : (isActive ? "Bu klasörde kayıtlı" : "Bu klasöre kaydet")}
                        aria-label={busy ? "İşleniyor…" : (isActive ? "Bu klasörde kayıtlı" : "Bu klasöre kaydet")}
                      >
                        {busy ? (
                          <span
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : isActive ? (
                          <FeatherIcon icon="check-circle" color="#007bff" size={22} />
                        ) : (
                          <FeatherIcon icon="plus-circle" color="#bdbdbd" size={22} />
                        )}
                      </span>
                    </OverlayTrigger>


                  </div>
                );
              })}
            </>
          )}
        </div>

        {/* Klasör oluştur alanı */}
        {creating ? (
          <div className="d-flex align-items-center p-3 border-top">
            <Form.Control
              type="text"
              placeholder="Klasör adı"
              value={newFolderName}
              autoFocus
              maxLength={50}
              style={{ fontSize: 15, borderRadius: 10 }}
              disabled={creatingBusy || togglingId !== null}
              onChange={(e) => setNewFolderName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleCreate();
                if (e.key === "Escape" && !creatingBusy) setCreating(false);
              }}
            />
            <Button
              className="ms-2"
              size="sm"
              variant="primary"
              onClick={handleCreate}
              disabled={
                creatingBusy ||
                togglingId !== null ||
                newFolderName.trim().length < 2
              }
            >
              {creatingBusy ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  />
                  Oluşturuluyor
                </>
              ) : (
                "Oluştur"
              )}
            </Button>
            <Button
              className="ms-2"
              size="sm"
              variant="light"
              onClick={() => setCreating(false)}
              disabled={creatingBusy}
            >
              İptal
            </Button>
          </div>
        ) : (
          <div className="d-flex align-items-center p-3 border-top">
            <Button
              className="w-100"
              size="sm"
              variant="outline-primary"
              onClick={() => setCreating(true)}
              style={{ borderRadius: 10 }}
              disabled={creatingBusy || togglingId !== null}
            >
              <FeatherIcon icon="plus" className="me-1" />
              Klasör Oluştur
            </Button>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0">
        <a
          href="https://idealonline.com.tr/panel/user/userpublications"
          className="btn btn-badgeblue btn-sm me-auto"
          target="_blank"
          rel="noopener noreferrer"
        >
          Klasörlerime git
        </a>

        <Button
          variant="outline-primary"
          size="sm"
          onClick={onHide}
          disabled={creatingBusy || togglingId !== null}
        >
          Kapat
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveModal;
